<template>
  <a-collapse style="margin-bottom:24px" :default-active-key="['app-system']">
    <a-collapse-panel key="app-system" header="APP 协议与软件信息">
      <a-spin :spinning="loading">
        <a-alert type="info" show-icon message="维护商城系统设置和注册入口使用的协议内容。中文用于国内版，英文用于国际版；英文未填写时使用中文。" style="margin-bottom:16px"/>
        <a-tabs v-model="active">
          <a-tab-pane v-for="doc in documents" :key="String(doc.id)" :tab="doc.title">
            <a-radio-group v-model="language" button-style="solid" style="margin-bottom:16px"><a-radio-button value="cn">中文内容</a-radio-button><a-radio-button value="en">英文内容</a-radio-button></a-radio-group>
            <editor v-if="active===String(doc.id)&&language==='cn'" :key="doc.id+'-cn'" v-model="doc.content" :height="360"/>
            <editor v-if="active===String(doc.id)&&language==='en'" :key="doc.id+'-en'" v-model="doc.contentEn" :height="360"/>
            <a-button type="primary" style="margin-top:16px" v-hasPermi="['config:config:edit']" :disabled="!loaded" :loading="saving===doc.id" @click="saveDocument(doc)">保存{{doc.title}}</a-button>
          </a-tab-pane>
          <a-tab-pane key="software" tab="软件信息">
            <a-form-model :model="software" :label-col="{span:4}" :wrapper-col="{span:18}">
              <a-form-model-item label="APP备案号"><a-input v-model="software.appIcp" :max-length="200" placeholder="填写实际 APP 备案号"/></a-form-model-item>
              <a-form-model-item label="备案详情链接"><a-input v-model="software.license" placeholder="https://beian.miit.gov.cn" :max-length="2000"/></a-form-model-item>
              <a-form-model-item :wrapper-col="{offset:4}"><a-button type="primary" v-hasPermi="['config:config:edit']" :disabled="!loaded" :loading="saving==='software'" @click="saveSoftware">保存软件信息</a-button></a-form-model-item>
            </a-form-model>
            <p class="hint">软件信息内的版权信息、许可协议分别在上方对应标签中维护。APP 名称、图标及版本号由安装包提供。</p>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </a-collapse-panel>
  </a-collapse>
</template>
<script>
import request from '@/utils/request'
import Editor from '@/components/Editor'
const url='/dkmall/content-settings/app-system'
export default {
  name:'AppSystemSettings',components:{Editor},
  data(){return {loading:false,loaded:false,saving:null,active:'1',language:'cn',documents:[],software:{appIcp:'',license:''}}},
  created(){this.load()},
  methods:{
    async load(){this.loading=true;this.loaded=false;try{const r=await request({url,method:'get'});const d=r.data||{};this.documents=(d.documents||[]).map(x=>({...x,content:x.content||'',contentEn:x.contentEn||''}));this.software={appIcp:d.appIcp||'',license:d.license||''};this.loaded=true}finally{this.loading=false}},
    async saveDocument(doc){if(!this.loaded)return;this.saving=doc.id;try{await request({url:`${url}/documents/${doc.id}`,method:'put',data:{content:doc.content,contentEn:doc.contentEn}});this.$message.success(doc.title+'已保存')}finally{this.saving=null}},
    async saveSoftware(){if(!this.loaded)return;if(this.software.license&&!/^https?:\/\/[^\s]+$/i.test(this.software.license.trim()))return this.$message.warning('请填写有效的 HTTP/HTTPS 备案链接');this.saving='software';try{await request({url:`${url}/software`,method:'put',data:{...this.software}});this.$message.success('软件信息已保存')}finally{this.saving=null}}
  }
}
</script>
<style scoped>.hint{color:#8c8c8c;margin-top:12px}</style>
